import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class WarehouseLocation {
  /* 库位列表 */
  static getWarehouseLocationList(options) {
    let url = `/oa/api/warehouse/area/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 库位导入 */
  static postUploadWarehouseLocationExcel(data) {
    const url = "/oa/api/upload/warehouse/area";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 添加库位 */
  static postAddWarehouseLocation(data) {
    const url = "/oa/api/warehouse/area/save";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 删除库位 */
  static postDelWarehouseLocation(data) {
    const url = "/oa/api/warehouse/area/delete";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default WarehouseLocation